import { CreditRiskScore } from '../../../../../../common/header/companyInfo/creditRiskScore'

export const ScoreFormat = ({ current, prev, scoreColor }) => {
  const formatCurrent =
    typeof current === 'number' && !isNaN(current) ? current : null
  const formatPrev = typeof prev === 'number' && !isNaN(prev) ? prev : null

  return (
    <CreditRiskScore
      score={formatCurrent}
      prevScore={formatPrev}
      isHiddenTextLink={true}
      appendStyle={{
        fontSize: 16,
        fontWeight: 700,
        width: 80,
        display: 'flex',
        justifyContent: 'center',
      }}
      styleIcon={{ fontSize: 14 }}
      scoreColor={scoreColor}
    />
  )
}
